import { dropBoolean } from 'utils/drops';

const getGrupoEntidadeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'vlrmaxaprova',
    label: 'Valor Máximo Aprovado',
    type: 'currency',
  },
  {
    name: 'aprova',
    label: 'Aprovação',
    type: 'select',
    options: drops?.Users,
    multiple: true,
  },
  {
    name: 'analisa',
    label: 'Análise',
    type: 'select',
    options: drops?.Users,
    multiple: true,
  },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getGrupoEntidadeFilterFields;
